import { AppConfig } from "../Config";
import constant from "../_config/constant";
import { clearBrowserSession } from '@crewmates/api-client-legacy';

export function processMediaUrl(inputString) {
  const urlRegex = /^(?:https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
  if (urlRegex.test(inputString)) {
    return inputString; // It's already a URL, return as is
  } else {
    const resultUrl = `${AppConfig.s3Endpoint}media/${inputString}`;
    return resultUrl;
  }
}

export function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (data.statusCode == 401 || data.statusCode == 403) {
      // Clear the in-memory browser session before redirecting.
      clearBrowserSession();
      window.location.replace("/");
    }
    if (data.statusCode != 200) {
      const error = (data && data.userMessage) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

export function propertyBookedCount(data) {
  let hotbedCount = 0
  let coldbedCount = 0
  const sleepingArrangements = data.sleepingArrangements
  if(sleepingArrangements != undefined && sleepingArrangements.length > 0) {
      sleepingArrangements.forEach((value) => {
          hotbedCount += value.hotbedBookedDates != undefined ? value.hotbedBookedDates.length : 0
          coldbedCount += value.coldbedBookedDates != undefined ? value.coldbedBookedDates.length : 0
          if(value.beds && value.beds.length > 0) {
              value.beds.forEach((bed) => {
                  hotbedCount += bed.hotbedBookedDates != undefined ? bed.hotbedBookedDates.length : 0
                  coldbedCount += bed.coldbedBookedDates != undefined ? bed.coldbedBookedDates.length : 0
              })
          }
      })
  }
  return {hotbedCount, coldbedCount}
}
